import * as React from 'react';

import { Box } from '~shared/components/Box';

import { UseIconProps, useIcon } from '../../useIcon';
import { IconExtractQuestionsSvg } from './IconExtractQuestionsSvg';

export type IconExtractQuestionsProps = UseIconProps;

export function IconExtractQuestions(props: IconExtractQuestionsProps) {
  const iconProps = useIcon({ size: 'large', ...props });

  return <Box tagName={IconExtractQuestionsSvg} {...iconProps} />;
}
